import { render, staticRenderFns } from "./CompanionHomePage.vue?vue&type=template&id=55c47018&scoped=true"
import script from "./CompanionHomePage.vue?vue&type=script&lang=js"
export * from "./CompanionHomePage.vue?vue&type=script&lang=js"
import style0 from "./CompanionHomePage.vue?vue&type=style&index=0&id=55c47018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c47018",
  null
  
)

export default component.exports